/**
 * The stored properties each instantiable resource class declares as a Variant, with any it adds
 * at run time, derived from Godot 4.6.3.stable.fedora.7d41c59c4's captures.
 * The text saver keeps a Nil only on such a property, and leaves out an empty Object
 * (`resource_format_text.cpp:1980`).
 * AUTO-GENERATED - Do not edit manually. Run: pnpm nodes:base-types
 */
export const VARIANT_PROPERTIES = Object.freeze({
    "BoneMap": [
        "bonemap",
    ],
    "Curve": [
        "_limits",
    ],
    "JSON": [
        "data",
    ],
});
//# sourceMappingURL=variantProperties.generated.js.map